<template>
  <v-dialog v-model="dialogProp" max-width="400">
    <v-card class="pb-3">
      <v-alert v-show="alertQuery" color="success" icon="new_releases" :value="true">
        El correo electronico fue enviado con exito, pronto nos comunicaremos contigo.
      </v-alert>
      <v-card-title>
        <span class="title">Solicitar Presupuesto</span>
        <v-spacer></v-spacer>
        <v-btn round flat @click.stop="$emit('dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-layout row>
            <v-flex xs4>
              <v-subheader>Nombre</v-subheader>
            </v-flex>
            <v-flex xs8>
              <v-text-field
                name="name"
                label="Nombre"
                v-model="name"
                :rules="nameRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs4>
              <v-subheader>Correo</v-subheader>
            </v-flex>
            <v-flex xs8>
              <v-text-field
                name="email"
                label="Correo Electronico"
                v-model="email"
                :rules="emailRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs4>
              <v-subheader>Consulta</v-subheader>
            </v-flex>
            <v-flex xs8>
              <v-text-field
                name="query"
                label="Consulta"
                v-model="query"
                :rules="queryRules"
                multi-line
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingBtn" color="primary" @click.stop="submit"  :disabled="!valid" class="mx-3">Enviar</v-btn>
          <v-btn color="secondary" @click.stop="clear">Limpiar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
export default {
  props: ['dialog'],
  data: () => ({
    name: '',
    nameRules: [
      v => !!v || 'Campo obligatorio',
      v => /[A-Za-z0-9_\-\á\é\í\ó\ú\Á\É\Ó\Ú\ñ\?\¿\!\s]$/i.test(v) || 'Algo está mal, revisa la información antes de continuar'
    ],
    email: '',
    emailRules: [
      v => !!v || 'Campo obligatorio',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    query: '',
    queryRules: [
      v => !!v || 'Campo obligatorio',
      v => /[A-Za-z0-9_\-\á\é\í\ó\ú\Á\É\Ó\Ú\ñ\?\¿\!\s]$/i.test(v) || 'Algo está mal, revisa la información antes de continuar'
    ],
    loadingBtn: false,
    alertQuery: false,
    valid: true,
  }),
  computed: {
    dialogProp: {
      get: function () {
        return this.dialog
      },
      set: function () {
        this.$emit('dialog', false)
      }
    }
  },

  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.alertQuery = true;
        axios.post('/mail.php', {
          name: this.name,
          email: this.email,
          query: this.query
        })
        .then(res => console.log(res))
        .catch(error => console.log(error));
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/addons/ContactDialog.vue